var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "129.332px",
    height: "129.333px",
    viewBox: "0 0 129.332 129.333",
    style: {
      enableBackground: "new 0 0 129.332 129.333"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prove_colore1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 2157.5415,
    y1: -120.9238,
    x2: 2373.313,
    y2: -336.6953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)",
      stroke: "#FFFFFF",
      strokeWidth: 11
    },
    d: "M2202-124.5h-37.182c-32.768,0-36.318-55.43-36.318-55.43 v-100.883c0,0,6.551-49.688,39.318-49.688h37.615c12.668,0,18.324,8.262,18.324,8.262l0,0l78.131,93.889l29.387,36.121 l-0.932-1.117l-32.531-40.092l0,0c-15.75-24.688-12.688-47.688-11.313-58.707v-0.117v0.117c0,0,6.994-42.355,39.764-42.355h37.613 c30.223,0,35.768,43,36.123,50l0,0c2,22.813-17.166,47.512-22.734,56.592L2345.5-266.5l0,0l31.766,38.551l0,0c0,0-2.595-5.053,0,0 c2.735,5.324,19.734,16.449,19.776,49.449l0,0c0,0-2.478,54-35.247,54c-9.404,0-37.615,0-37.615,0 c-10.969,0-16.617-7.5-23.363-14.807l0,0l-93.635-111.021l-14.755-0.083c0,0-9.927,12.645-9.927,12.642v41.263v-41.263 l9.927-12.712l15.001,0.015l29.015,34.904l0,0l-0.05,36.296c0,0-1.188,54.766-33.959,54.766h-37.615 c-32.768,0-36.318-55.43-36.318-55.43v-100.883c0,0,6.551-49.688,39.318-49.688H2206"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2342.105-193.292c6.492-0.003,11.754,5.989,11.758,13.381 c0.002,7.393-5.26,13.39-11.754,13.392c-6.49,0.001-11.754-5.991-11.758-13.383C2330.35-187.297,2334.289-193.289,2342.105-193.292 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2182.613-195.292c6.492-0.003,11.754,5.989,11.758,13.381 c0,7.394-5.259,13.39-11.754,13.392c-6.492,0.001-11.754-5.991-11.758-13.383C2170.857-189.297,2174.797-195.289,2182.613-195.292z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2340.6-289.478c6.494-0.003,11.756,5.986,11.758,13.382 c0.004,7.391-5.26,13.387-11.752,13.389c-6.49,0.002-11.756-5.99-11.758-13.382C2328.844-283.482,2332.783-289.477,2340.6-289.478z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2196F3",
      stroke: "#FFFFFF",
      strokeWidth: 7
    },
    d: "M1895.147,390"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#34373C",
      strokeWidth: 10
    },
    d: "M1686-666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF0000"
    },
    d: "M2183-180.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 11
    },
    d: "M2331.275-192.229"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 2157.6533,
    y1: -520.8125,
    x2: 2373.4248,
    y2: -736.584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)",
      stroke: "#FFFFFF",
      strokeWidth: 11
    },
    d: "M2202-524.5h-37.182c-32.768,0-36.318-55.43-36.318-55.43 v-100.883c0,0,6.551-49.688,39.318-49.688h37.615c12.668,0,18.324,8.262,18.324,8.262l0,0l78.131,93.889l29.387,36.121 l-0.932-1.117l-32.531-40.092l0,0c-15.75-24.688-12.688-47.688-11.313-58.707v-0.117v0.117c0,0,6.994-42.355,39.764-42.355h37.613 c30.223,0,35.768,43,36.123,50l0,0c2,22.813-10.25,41-15.818,50.08l-34.849-36.413l0,0l34.849,36.755l0,0c0,0-3.75-4.266,0,0 c4.706,5.354,19.352,22.569,15.818,55.569l0,0c0,0-5.436,54.009-38.205,54.009c-9.404,0-37.615,0-37.615,0 c-10.969,0-16.617-7.5-23.363-14.807l0,0l-93.635-111.021l-14.755-0.083c0,0-9.927,12.645-9.927,12.642v41.263v-41.263 l9.927-12.712l15.001,0.015l29.015,34.904l0,0l-0.05,36.296c0,0-1.188,54.766-33.959,54.766h-37.615 c-32.768,0-36.318-55.43-36.318-55.43v-100.883c0,0,6.551-49.688,39.318-49.688H2206"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2341.105-594.292c6.492-0.003,11.754,5.989,11.758,13.381 c0.002,7.393-5.26,13.39-11.754,13.392c-6.49,0.001-11.754-5.991-11.758-13.383C2329.35-588.297,2333.289-594.289,2341.105-594.292 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2182.613-594.292c6.492-0.003,11.754,5.989,11.758,13.381 c0,7.394-5.259,13.39-11.754,13.392c-6.492,0.001-11.754-5.991-11.758-13.383C2170.857-588.297,2174.797-594.289,2182.613-594.292z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#FFFFFF",
      strokeWidth: 9.7189
    },
    d: "M2340.6-693.478c6.494-0.003,11.756,5.986,11.758,13.382 c0.004,7.391-5.26,13.387-11.752,13.389c-6.49,0.002-11.756-5.99-11.758-13.382C2328.844-687.482,2332.783-693.477,2340.6-693.478z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 11
    },
    d: "M2331.275-592.229"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1497.6533,
    y1: -520.8115,
    x2: 1713.4249,
    y2: -736.5831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)",
      stroke: "#333333",
      strokeWidth: 11
    },
    d: "M1542-524.5h-37.182c-32.768,0-36.318-55.43-36.318-55.43 v-100.883c0,0,6.551-49.688,39.318-49.688h37.615c12.668,0,18.324,8.262,18.324,8.262l0,0l78.131,93.889l29.387,36.121 l-0.932-1.117l-32.531-40.092l0,0c-15.75-24.688-12.688-47.688-11.313-58.707v-0.117v0.117c0,0,6.994-42.355,39.764-42.355h37.613 c30.223,0,35.768,43,36.123,50l0,0c2,22.813-10.25,41-15.818,50.08l-34.849-36.413l0,0l34.849,36.755l0,0c0,0-3.75-4.266,0,0 c4.706,5.354,19.352,22.569,15.818,55.569l0,0c0,0-5.436,54.009-38.205,54.009c-9.404,0-37.615,0-37.615,0 c-10.969,0-16.617-7.5-23.363-14.807l0,0l-93.635-111.021l-14.755-0.083c0,0-9.927,12.645-9.927,12.642v41.263v-41.263 l9.927-12.712l15.001,0.015l29.015,34.904l0,0l-0.05,36.296c0,0-1.188,54.766-33.959,54.766h-37.615 c-32.768,0-36.318-55.43-36.318-55.43v-100.883c0,0,6.551-49.688,39.318-49.688H1546"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1681.105-594.292c6.492-0.003,11.754,5.989,11.758,13.381 c0.002,7.393-5.26,13.39-11.754,13.392c-6.49,0.001-11.754-5.991-11.758-13.383C1669.35-588.297,1673.289-594.289,1681.105-594.292 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1522.613-594.292c6.492-0.003,11.754,5.989,11.758,13.381 c0,7.394-5.259,13.39-11.754,13.392c-6.492,0.001-11.754-5.991-11.758-13.383C1510.857-588.297,1514.797-594.289,1522.613-594.292z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1680.6-693.478c6.494-0.003,11.756,5.986,11.758,13.382 c0.004,7.391-5.26,13.387-11.752,13.389c-6.49,0.002-11.756-5.99-11.758-13.382C1668.844-687.482,1672.783-693.477,1680.6-693.478z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1497.6533,
    y1: -110.8125,
    x2: 1713.4247,
    y2: -326.5838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)",
      stroke: "#333333",
      strokeWidth: 11
    },
    d: "M1542-114.5h-37.182c-32.768,0-36.318-55.43-36.318-55.43 v-100.883c0,0,6.551-49.688,39.318-49.688h37.615c12.668,0,18.324,8.262,18.324,8.262l0,0l78.131,93.889l29.387,36.121 l-0.932-1.117l-32.531-40.092l0,0c-15.75-24.688-12.688-47.688-11.313-58.707v-0.117v0.117c0,0,6.994-42.355,39.764-42.355h37.613 c30.223,0,35.768,43,36.123,50l0,0c2,22.813-10.25,41-15.818,50.08l-34.849-36.413l0,0l34.849,36.755l0,0c0,0-3.75-4.266,0,0 c4.706,5.354,19.352,22.569,15.818,55.569l0,0c0,0-5.436,54.009-38.205,54.009c-9.404,0-37.615,0-37.615,0 c-10.969,0-16.617-7.5-23.363-14.807l0,0l-93.635-111.021l-14.755-0.083c0,0-9.927,12.645-9.927,12.642v41.263v-41.263 l9.927-12.712l15.001,0.015l29.015,34.904l0,0l-0.05,36.296c0,0-1.188,54.766-33.959,54.766h-37.615 c-32.768,0-36.318-55.43-36.318-55.43v-100.883c0,0,6.551-49.688,39.318-49.688H1546"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1681.105-184.292c6.492-0.003,11.754,5.989,11.758,13.381 c0.002,7.393-5.26,13.39-11.754,13.392c-6.49,0.001-11.754-5.991-11.758-13.383C1669.35-178.297,1673.289-184.289,1681.105-184.292 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1522.613-184.292c6.492-0.003,11.754,5.989,11.758,13.381 c0,7.394-5.259,13.39-11.754,13.392c-6.492,0.001-11.754-5.991-11.758-13.383C1510.857-178.297,1514.797-184.289,1522.613-184.292z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 9.7189
    },
    d: "M1680.6-283.478c6.494-0.003,11.756,5.986,11.758,13.382 c0.004,7.391-5.26,13.387-11.752,13.389c-6.49,0.002-11.756-5.99-11.758-13.382C1668.844-277.482,1672.783-283.477,1680.6-283.478z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF0000"
    },
    d: "M1533-580.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 11
    },
    d: "M1681.275-592.229"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.5,
    y: -719.5,
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 490,
    cy: -270,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 490,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 790,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000",
      strokeWidth: 0.2567
    },
    cx: 790,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000",
      strokeWidth: 0.2567
    },
    cx: 790,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000",
      strokeWidth: 0.2567
    },
    cx: 790,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 790,
    cy: -570,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 790,
    cy: -270,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 490,
    cy: -570,
    r: 150
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    points: "790,-270 580.438,-689.688 489.999,-570 699.422,-150.453  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    x1: 379.999,
    y1: -150.453,
    x2: 589.422,
    y2: -570
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    points: "790,-570 880.219,-389.828 790,-270 640.016,-569.766  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 790,
    cy: -270,
    r: 38.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    cx: 790,
    cy: -570,
    r: 38.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    x1: 489.5,
    y1: -270,
    x2: 489.5,
    y2: -570
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    d: "M489.5-420"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FF0000",
      stroke: "#000000"
    },
    x1: 490,
    y1: -419.5,
    x2: 638,
    y2: -419.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M2170.418-1295.972c1.192-6.567,3.354-12.64,8.763-17.188 c9.132-7.677,22.359-8.162,31.248-0.901c9.781,7.989,12.42,20.515,6.225,31.345c-1.587,2.774-1.8,4.542-0.114,7.462 c6.475,11.222,3.579,23.895-6.691,32.056c-6.888,5.474-22.143,7.571-31.053-2.273c-3.793-4.191-7.428-8.524-11.106-12.818 c-1.589-1.854-3.108-3.771-5.351-6.5c-0.23,2.161-0.403,3.211-0.445,4.266c-0.491,12.444-10.336,22.018-22.611,21.966 c-12.558-0.053-22.418-9.817-22.543-22.551c-0.118-11.826-0.105-23.653,0.001-35.479c0.088-9.719,6.064-18.29,14.589-21.316 c9.035-3.207,19.104-0.572,25.423,6.717c4.354,5.023,8.642,10.104,12.972,15.147 C2169.799-1295.951,2170.039-1296.003,2170.418-1295.972z M2133.266-1257.997c0.923-4.981,2.247-9.426,2.469-13.925 c0.359-7.31-0.194-14.661,0.078-21.979c0.065-1.781,1.471-4.194,2.968-4.997c0.952-0.511,3.684,1.007,4.798,2.313 c4.75,5.566,9.117,11.456,13.764,17.113c8.134,9.902,16.014,20.046,24.668,29.476c7.599,8.28,19.785,7.968,27.138,0.23 c7.545-7.938,7.21-19.429-0.795-27.286c-2.733-2.683-5.335-5.521-8.243-7.998c-2.743-2.337-5.813-4.292-9.384-6.883 c0-1.505,0-4.243,0-7.012c3.233,0,6.103,0,8.959,0c0.041,8.143,6.925,10.473,10.909,15.394c6.156-9.458,4.719-19.641-3.181-26.054 c-7.433-6.034-18.905-5.482-25.564,1.233c-7.312,7.371-7.613,17.378-0.688,25.623c3.213,3.824,6.399,7.694,9.91,11.233 c2.257,2.273,5.083,3.982,7.653,5.943c0.317-0.275,0.636-0.552,0.953-0.827c0,2.733,0,5.467,0,8.366c-3.183,0-6.062,0-8.442,0 c-0.933-2.599-1.183-5.137-2.531-6.764c-12.006-14.476-24.138-28.848-36.38-43.123c-4.967-5.792-11.477-7.168-18.602-4.907 c-7.141,2.266-11.138,7.701-11.419,14.879c-0.495,12.64-0.511,25.327-0.042,37.968c0.348,9.423,8.046,16.063,17.215,15.992 c9.201-0.072,15.522-6.928,17.055-16.265c2.19-13.365-8.256-19.28-13.945-28.039c-0.563,0.166-1.127,0.331-1.689,0.496 c0.895,9.948,1.789,19.897,2.681,29.798C2140.103-1257.997,2137.175-1257.997,2133.266-1257.997z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    d: "M434.69-1098.869c12.182,0,22.052-9.875,22.052-22.053 c0-12.178-9.87-22.052-22.052-22.052c-12.182,0-22.052,9.874-22.052,22.052C412.638-1108.743,422.508-1098.869,434.69-1098.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    d: "M849.458-1311.559c-5.013,1.979-10.469,3.079-16.185,3.079 c-24.356,0-44.106-19.749-44.106-44.105c0-24.357,19.75-44.106,44.106-44.106c24.356,0,44.103,19.749,44.103,44.106 c0,6.636-1.475,12.925-4.101,18.571c14.103,14.878,39.588,41.63,61.797,64.217c44.665-44.663,41.5-143.852-14.809-189.564 c-52.978-43.013-134.758-39.075-182.227,8.791c-52.118,52.542-54.267,123.877-4.899,182.642 c6.738,8.303,64.691,78.112,86.944,104.91c4.166-1.304,8.596-2.009,13.191-2.009c24.356,0,44.103,19.748,44.103,44.104 c0,24.357-19.747,44.106-44.103,44.106c-24.356,0-44.106-19.75-44.106-44.106c0-6.924,1.6-13.474,4.444-19.305 c-49.098-57.044-254.448-295.551-262.464-303.562c-37.06-40.963-85.166-54.661-135.953-38.539 c-50.9,16.153-81.195,54.856-81.195,106.058c0,91.549,0,180.688,0,270.643c0,67.211,56.851,114.502,122.208,113.994 c65.586-0.515,110.545-49.381,121.466-115.936c5.856-35.729,0-87.854,0-87.854l-77.838-94.004 C469.5-1302.377,462.167-1315,456.706-1314c-5.975,1.094-5.706,8.792-5.706,18.25v17.125v116.554 c16,6.375,28.016,22.39,28.016,41.15c0,24.357-19.859,44.106-44.216,44.106s-44.739-19.75-44.739-44.106 c0-18.508,12.939-34.346,28.939-40.889v-116.815V-1315c0-16.568,6.75-32.5,23.625-37c26.439-7.05,41.606,17.083,52.464,30.264 c52.487,63.719,197.448,240.805,243.924,287.278c59.106,59.109,141.117,56.795,193.527,1.642 c53.782-56.585,36.864-156.533-20.196-212.542C909.304-1248.399,869.179-1289.795,849.458-1311.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    d: "M833.274-1098.869c12.174,0,22.051-9.875,22.051-22.053 c0-12.178-9.877-22.052-22.051-22.052c-12.175,0-22.054,9.874-22.054,22.052C811.22-1108.743,821.099-1098.869,833.274-1098.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    d: "M833.274-1374.638c-12.175,0-22.054,9.875-22.054,22.053 c0,12.179,9.879,22.053,22.054,22.053c12.174,0,22.051-9.874,22.051-22.053C855.325-1364.763,845.448-1374.638,833.274-1374.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000"
    },
    cx: 2385.603,
    cy: -1259.081,
    r: 3.947
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000"
    },
    d: "M2459.845-1293.204 c-0.897,0.354-1.874,0.551-2.897,0.551c-4.359,0-7.895-3.535-7.895-7.895c0-4.36,3.535-7.895,7.895-7.895s7.895,3.535,7.895,7.895 c0,1.188-0.264,2.313-0.734,3.324c2.524,2.663,7.086,7.452,11.062,11.495c7.995-7.994,7.429-25.749-2.65-33.931 c-9.483-7.699-24.121-6.994-32.618,1.574c-9.328,9.405-9.713,22.173-0.877,32.692c1.206,1.486,11.58,13.981,15.563,18.778 c0.746-0.233,1.539-0.359,2.361-0.359c4.359,0,7.895,3.535,7.895,7.895s-3.535,7.895-7.895,7.895s-7.895-3.535-7.895-7.895 c0-1.24,0.286-2.412,0.795-3.456c-8.788-10.211-45.545-52.902-46.979-54.336c-6.633-7.333-15.494-9.784-24.585-6.898 c-9.11,2.891-14.783,9.819-14.783,18.984c0,16.387,0,32.342,0,48.444c0,12.03,10.427,20.495,22.125,20.404 c11.739-0.092,19.912-8.839,21.866-20.751c1.049-6.396-0.65-16.083-0.65-16.083l-13.188-16.469 c-1.85-2.318-3.158-4.577-4.135-4.398c-1.07,0.196-1.018,1.574-1.018,3.267v3.065v20.863c2,1.141,5.025,4.007,5.025,7.366 c0,4.36-3.548,7.895-7.908,7.895c-4.359,0-8.153-3.535-8.153-7.895c0-3.313,2.036-6.148,5.036-7.319v-20.91v-6.511 c0-2.965,1.355-5.817,4.377-6.623c4.732-1.262,7.521,3.058,9.463,5.417c9.396,11.405,35.38,43.103,43.698,51.421 c10.58,10.581,25.278,10.166,34.659,0.294c9.627-10.128,6.607-28.019-3.605-38.044 C2470.548-1281.899,2463.375-1289.309,2459.845-1293.204z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000"
    },
    cx: 2456.947,
    cy: -1259.081,
    r: 3.947
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000"
    },
    cx: 2456.947,
    cy: -1300.548,
    r: 3.947
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2752.635,
    y: -1340.5,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2752.6348 -1310.9404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.881,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2821.992,
    cy: -1412.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M2996.923-1493.073c-2.114,0.834-4.416,1.299-6.827,1.299 c-10.271,0-18.602-8.329-18.602-18.601c0-10.274,8.33-18.603,18.602-18.603c10.271,0,18.602,8.329,18.602,18.603 c0,2.798-0.621,5.45-1.73,7.832c5.948,6.274,16.695,17.558,26.063,27.084c18.84-18.836,17.505-60.669-6.244-79.949 c-22.346-18.14-56.834-16.479-76.855,3.708c-21.979,22.16-22.887,52.245-2.066,77.029c2.843,3.502,27.285,32.943,36.67,44.246 c1.757-0.55,3.625-0.847,5.563-0.847c10.271,0,18.602,8.329,18.602,18.602s-8.331,18.602-18.602,18.602 c-10.271,0-18.602-8.329-18.602-18.602c0-2.921,0.674-5.683,1.875-8.142c-20.708-24.059-107.314-124.649-110.695-128.027 c-15.628-17.276-36.964-23.053-58.385-16.254c-21.465,6.813-35.289,23.135-35.289,44.73c0,38.61,0,76.205,0,114.144 c0,28.346,25.025,48.291,52.59,48.076c27.659-0.216,47.144-20.826,51.747-48.895c2.473-15.069,0-37.896,0-37.896l-32.436-38.804 c-4.356-5.461-7.321-10.785-9.622-10.362c-2.521,0.461-2.279,3.708-2.279,7.696v7.222v49.157c5,2.688,11.75,9.442,11.75,17.355 c0,10.273-8.404,18.602-18.678,18.602c-10.271,0-19.075-8.329-19.075-18.602c0-7.806,4.003-14.486,12.003-17.245v-49.268v-15.341 c0-6.987,3.036-13.707,10.155-15.604c11.149-2.975,17.638,7.204,22.215,12.763c22.14,26.873,83.322,101.56,102.924,121.16 c24.928,24.93,59.54,23.953,81.644,0.692c22.684-23.864,15.56-66.017-8.505-89.639 C3022.153-1466.436,3005.24-1483.894,2996.923-1493.073z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2990.096,
    cy: -1412.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2990.096,
    cy: -1510.376,
    r: 9.301
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3406.633,
    y: -1340.5,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 3406.6328 -1310.9404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#BBBBBB",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.881,
    y: 0,
    style: {
      fill: "#BBBBBB",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3474.99,
    cy: -1412.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M3650.921-1493.073c-2.114,0.834-4.416,1.299-6.827,1.299 c-10.271,0-18.602-8.329-18.602-18.601c0-10.274,8.33-18.603,18.602-18.603c10.271,0,18.602,8.329,18.602,18.603 c0,2.798-0.621,5.45-1.73,7.832c5.948,6.274,16.695,17.558,26.063,27.084c18.84-18.836,17.504-60.669-6.244-79.949 c-22.346-18.14-56.834-16.479-76.855,3.708c-21.98,22.16-22.887,52.245-2.066,77.029c2.843,3.502,27.285,32.943,36.67,44.246 c1.757-0.55,3.625-0.847,5.563-0.847c10.271,0,18.602,8.329,18.602,18.602s-8.331,18.602-18.602,18.602 c-10.271,0-18.602-8.329-18.602-18.602c0-2.921,0.674-5.683,1.875-8.142c-20.708-24.059-107.314-124.649-110.695-128.027 c-15.628-17.276-37.463-23.053-58.884-16.254c-21.465,6.813-35.788,23.135-35.788,44.73c0,38.61,0,76.205,0,114.144 c0,28.346,25.524,48.291,53.089,48.076c27.659-0.216,47.394-20.826,51.997-48.895c2.473-15.069,0-37.896,0-37.896l-32.249-38.804 c-4.356-5.461-7.789-10.785-10.09-10.362c-2.521,0.461-2.747,3.708-2.747,7.696v7.222v49.157c5,2.688,12.249,9.442,12.249,17.355 c0,10.273-8.155,18.602-18.429,18.602c-10.271,0-19.449-8.329-19.449-18.602c0-7.806,3.629-14.486,11.629-17.245v-49.268v-15.341 c0-6.987,3.535-13.707,10.654-15.604c11.149-2.975,17.887,7.204,22.465,12.763c22.139,26.873,83.446,101.56,103.048,121.16 c24.928,24.93,59.603,23.953,81.706,0.692c22.684-23.864,15.591-66.017-8.475-89.639 C3676.12-1466.436,3659.238-1483.894,3650.921-1493.073z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3644.094,
    cy: -1412.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3644.094,
    cy: -1510.376,
    r: 9.301
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2752.635,
    y: -945.5,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2752.6348 -915.9404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.879,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2821.992,
    cy: -1017.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 2773.4678,
    y1: -991.2065,
    x2: 3039.3853,
    y2: -1144.7341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_17_)"
    },
    d: "M2996.923-1098.073 c-2.114,0.834-4.416,1.299-6.827,1.299c-10.271,0-18.602-8.329-18.602-18.601c0-10.274,8.33-18.603,18.602-18.603 c10.271,0,18.602,8.329,18.602,18.603c0,2.798-0.621,5.45-1.73,7.832c5.948,6.274,16.695,17.558,26.063,27.084 c18.84-18.836,17.505-60.669-6.244-79.949c-22.346-18.14-56.834-16.479-76.855,3.708c-21.979,22.16-22.887,52.245-2.066,77.029 c2.843,3.502,27.285,32.943,36.67,44.246c1.757-0.55,3.625-0.847,5.563-0.847c10.271,0,18.602,8.329,18.602,18.602 s-8.331,18.602-18.602,18.602c-10.271,0-18.602-8.329-18.602-18.602c0-2.921,0.674-5.683,1.875-8.142 c-20.708-24.059-107.314-124.649-110.695-128.027c-15.628-17.276-36.964-23.053-58.385-16.254 c-21.465,6.813-35.289,23.135-35.289,44.73c0,38.61,0,76.205,0,114.144c0,28.346,25.025,48.291,52.59,48.076 c27.659-0.216,47.144-20.826,51.747-48.895c2.473-15.069,0-37.896,0-37.896l-32.436-38.804 c-4.356-5.461-7.321-10.785-9.622-10.362c-2.521,0.461-2.279,3.708-2.279,7.696v7.222v49.157c5,2.688,11.75,9.442,11.75,17.355 c0,10.273-8.404,18.602-18.678,18.602c-10.271,0-19.075-8.329-19.075-18.602c0-7.806,4.003-14.486,12.003-17.245v-49.268v-15.341 c0-6.987,3.036-13.707,10.155-15.604c11.149-2.975,17.638,7.204,22.215,12.763c22.14,26.873,83.322,101.56,102.924,121.16 c24.928,24.93,59.54,23.953,81.644,0.692c22.684-23.864,15.56-66.017-8.505-89.639 C3022.153-1071.436,3005.24-1088.894,2996.923-1098.073z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2990.096,
    cy: -1017.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 2990.096,
    cy: -1115.376,
    r: 9.301
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3406.633,
    y: -945.5,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 3406.6328 -915.9404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#BBBBBB",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.879,
    y: 0,
    style: {
      fill: "#BBBBBB",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3475.99,
    cy: -1017.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 3427.4668,
    y1: -991.207,
    x2: 3693.3828,
    y2: -1144.7336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577,
    style: {
      stopColor: "#7CD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#6FD3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#5BCCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#40C4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#0091EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_18_)"
    },
    d: "M3650.921-1098.073 c-2.114,0.834-4.416,1.299-6.827,1.299c-10.271,0-18.602-8.329-18.602-18.601c0-10.274,8.33-18.603,18.602-18.603 c10.271,0,18.602,8.329,18.602,18.603c0,2.798-0.621,5.45-1.73,7.832c5.948,6.274,16.695,17.558,26.063,27.084 c18.84-18.836,17.504-60.669-6.244-79.949c-22.346-18.14-56.834-16.479-76.855,3.708c-21.98,22.16-22.887,52.245-2.066,77.029 c2.843,3.502,27.285,32.943,36.67,44.246c1.757-0.55,3.625-0.847,5.563-0.847c10.271,0,18.602,8.329,18.602,18.602 s-8.331,18.602-18.602,18.602c-10.271,0-18.602-8.329-18.602-18.602c0-2.921,0.674-5.683,1.875-8.142 c-20.708-24.059-107.314-124.649-110.695-128.027c-15.628-17.276-36.963-23.053-58.384-16.254 c-21.465,6.813-35.288,23.135-35.288,44.73c0,38.61,0,76.205,0,114.144c0,28.346,25.024,48.291,52.589,48.076 c27.659-0.216,47.144-20.826,51.747-48.895c2.473-15.069,0-37.896,0-37.896l-32.438-38.804 c-4.355-5.461-7.319-10.785-9.62-10.362c-2.521,0.461-2.278,3.708-2.278,7.696v7.222v49.157c5,2.688,11.749,9.442,11.749,17.355 c0,10.273-8.405,18.602-18.679,18.602c-10.271,0-19.074-8.329-19.074-18.602c0-7.806,4.004-14.486,12.004-17.245v-49.268v-15.341 c0-6.987,3.035-13.707,10.154-15.604c11.149-2.975,17.637,7.204,22.215,12.763c22.139,26.873,83.321,101.56,102.923,121.16 c24.927,24.93,59.54,23.953,81.644,0.692c22.684-23.864,15.56-66.017-8.505-89.639 C3676.15-1071.436,3659.238-1088.894,3650.921-1098.073z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3644.094,
    cy: -1017.672,
    r: 9.301
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    cx: 3644.094,
    cy: -1115.376,
    r: 9.301
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3900,
    y: -1412.502,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 3900 -1382.9434)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.879,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 3969.357,
    cy: -1484.674,
    r: 9.301
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M4144.287-1565.075c-2.113,0.834-4.415,1.299-6.826,1.299 c-10.271,0-18.602-8.329-18.602-18.601c0-10.274,8.33-18.603,18.602-18.603c10.271,0,18.602,8.329,18.602,18.603 c0,2.798-0.621,5.45-1.73,7.832c5.948,6.274,16.695,17.558,26.063,27.084c18.84-18.836,17.504-60.669-6.244-79.949 c-22.346-18.14-56.834-16.479-76.855,3.708c-21.98,22.16-22.887,52.245-2.066,77.029c2.842,3.502,27.285,32.943,36.67,44.246 c1.757-0.55,3.625-0.847,5.563-0.847c10.271,0,18.602,8.329,18.602,18.602s-8.331,18.602-18.602,18.602 c-10.271,0-18.602-8.329-18.602-18.602c0-2.921,0.674-5.683,1.875-8.142c-20.708-24.059-107.314-124.649-110.695-128.027 c-15.628-17.276-37.146-23.053-58.567-16.254c-21.465,6.813-35.472,23.135-35.472,44.73c0,38.61,0,76.205,0,114.144 c0,28.346,25.208,48.291,52.772,48.076c27.659-0.216,47.235-20.826,51.839-48.895c2.473-15.069,0.045-37.896,0.045-37.896 l-32.414-38.804c-4.355-5.461-7.491-10.785-9.792-10.362c-2.521,0.461-2.45,3.708-2.45,7.696v7.222v49.157 c5,2.688,11.934,9.442,11.934,17.355c0,10.273-8.314,18.602-18.588,18.602c-10.271,0-19.212-8.329-19.212-18.602 c0-7.806,3.866-14.486,11.866-17.245v-49.268v-15.341c0-6.987,3.219-13.707,10.338-15.604 c11.148-2.975,17.729,7.204,22.307,12.763c22.139,26.873,83.367,101.56,102.969,121.16c24.928,24.93,59.563,23.953,81.666,0.692 c22.684-23.864,15.571-66.017-8.493-89.639C4169.506-1538.438,4152.605-1555.896,4144.287-1565.075z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 4137.461,
    cy: -1484.674,
    r: 9.301
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 4137.461,
    cy: -1582.378,
    r: 9.301
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 4014.135,
    y: -783.574,
    style: {
      fill: "none"
    },
    width: 309.734,
    height: 36.167
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4014.1348 -754.0137)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.6,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 125,
    y: 0,
    style: {
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.08,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 40
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.879,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 40
    }
  }, "agliano")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 3918.3,
    cy: -766.36,
    r: 3.212
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M3978.709-794.125c-0.73,0.288-1.523,0.449-2.355,0.449 c-3.546,0-6.425-2.877-6.425-6.424s2.879-6.424,6.425-6.424c3.545,0,6.422,2.877,6.422,6.424c0,0.967-0.213,1.881-0.597,2.705 c2.054,2.167,5.767,6.063,8.999,9.354c6.508-6.505,6.046-20.953-2.155-27.61c-7.718-6.265-19.626-5.69-26.541,1.28 c-7.591,7.653-7.903,18.042-0.713,26.602c0.979,1.209,9.423,11.376,12.664,15.279c0.606-0.19,1.249-0.293,1.921-0.293 c3.545,0,6.422,2.877,6.422,6.424c0,3.548-2.877,6.424-6.422,6.424c-3.546,0-6.425-2.876-6.425-6.424 c0-1.008,0.232-1.962,0.647-2.812c-7.151-8.309-37.06-43.046-38.228-44.211c-5.397-5.967-12.765-7.962-20.163-5.614 c-7.413,2.353-12.186,7.99-12.186,15.447c0,13.334,0,26.317,0,39.418c0,9.788,8.641,16.677,18.161,16.602 c9.553-0.075,16.28-7.192,17.87-16.886c0.854-5.203,0-13.086,0-13.086l-11.201-13.4c-1.503-1.887-2.889-3.725-3.682-3.578 c-0.873,0.158-1.148,1.279-1.148,2.657v2.495v16.976c2,0.928,4.418,3.261,4.418,5.993c0,3.548-2.723,6.424-6.271,6.424 c-3.547,0-6.439-2.876-6.439-6.424c0-2.695,1.293-5.003,4.293-5.955v-17.014v-5.298c0-2.413,0.992-4.734,3.449-5.389 c3.85-1.027,6.062,2.488,7.644,4.408c7.647,9.28,28.761,35.072,35.53,41.841c8.609,8.609,20.556,8.272,28.187,0.239 c7.834-8.24,5.37-22.798-2.94-30.956C3987.426-784.926,3981.582-790.956,3978.709-794.125z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 3976.354,
    cy: -766.36,
    r: 3.212
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M3976.354-803.313c-1.774,0-3.213,1.438-3.213,3.212 c0,1.773,1.438,3.212,3.213,3.212c1.771,0,3.21-1.439,3.21-3.212C3979.563-801.875,3978.125-803.313,3976.354-803.313z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#333333"
    },
    cx: 64.666,
    cy: 64.666,
    r: 64.666
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 35.136,
    cy: 82.01,
    r: 3.212
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M95.545,54.244c-0.73,0.288-1.523,0.449-2.355,0.449 c-3.546,0-6.425-2.877-6.425-6.424c0-3.548,2.879-6.425,6.425-6.425c3.545,0,6.422,2.877,6.422,6.425 c0,0.967-0.213,1.881-0.598,2.704c2.055,2.167,5.768,6.063,9,9.354c6.508-6.506,6.046-20.953-2.155-27.611 c-7.718-6.264-19.626-5.689-26.541,1.281C71.727,41.65,71.414,52.04,78.604,60.6c0.979,1.209,9.423,11.376,12.664,15.279 c0.606-0.191,1.249-0.293,1.921-0.293c3.545,0,6.422,2.877,6.422,6.424c0,3.549-2.877,6.424-6.422,6.424 c-3.546,0-6.425-2.875-6.425-6.424c0-1.008,0.231-1.962,0.647-2.813c-7.151-8.309-37.06-43.045-38.228-44.211 c-5.397-5.967-12.683-7.962-20.081-5.613C21.69,31.725,17,37.362,17,44.819c0,13.334,0,26.317,0,39.419 c0,9.787,8.559,16.677,18.079,16.602c9.553-0.074,16.239-7.191,17.829-16.886c0.854-5.203-0.021-13.086-0.021-13.086l-11.211-13.4 c-1.503-1.887-2.812-3.725-3.605-3.578C37.198,54.048,37,55.169,37,56.547v2.494v16.976c2,0.929,4.336,3.261,4.336,5.993 c0,3.549-2.764,6.424-6.313,6.424c-3.547,0-6.378-2.875-6.378-6.424c0-2.695,1.354-5.003,4.354-5.955V59.041v-5.298 c0-2.413,0.91-4.733,3.367-5.389c3.85-1.026,6.021,2.487,7.603,4.407c7.647,9.281,28.74,35.072,35.51,41.842 c8.609,8.608,20.544,8.271,28.176,0.238c7.833-8.24,5.365-22.798-2.946-30.955C104.267,63.443,98.418,57.414,95.545,54.244z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 93.189,
    cy: 82.01,
    r: 3.212
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M93.189,45.057c-1.774,0-3.213,1.438-3.213,3.213 c0,1.773,1.438,3.212,3.213,3.212c1.771,0,3.209-1.438,3.209-3.212C96.398,46.495,94.961,45.057,93.189,45.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4273.872,
    y: 1083.571,
    style: {
      fill: "none"
    },
    width: 1117.708,
    height: 101.625
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4273.873 1166.6289)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 112.3915
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.169,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 112.3915
    }
  }, "icola"), /*#__PURE__*/React.createElement("tspan", {
    x: 351.22,
    y: 0,
    style: {
      fill: "#3FA9F5",
      fontFamily: "'TeXGyreAdventor-Bold'",
      fontSize: 112.3915
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 409.662,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'TeXGyreAdventor-Regular'",
      fontSize: 112.3915
    }
  }, "agliano.com")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M4001.008,1139.57c5.14,0,9.308-4.166,9.308-9.308 c0-5.143-4.168-9.307-9.308-9.307c-5.146,0-9.313,4.164-9.313,9.307C3991.695,1135.404,3995.861,1139.57,4001.008,1139.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3FA9F5"
    },
    d: "M4176.084,1049.794c-2.113,0.834-4.42,1.302-6.831,1.302 c-10.282,0-18.617-8.337-18.617-18.62s8.335-18.616,18.617-18.616c10.274,0,18.616,8.333,18.616,18.616 c0,2.804-0.622,5.453-1.734,7.837c5.955,6.282,16.711,17.577,26.088,27.108c18.854-18.851,17.52-60.721-6.25-80.019 c-22.366-18.154-56.882-16.49-76.922,3.712c-21.998,22.181-22.904,52.292-2.068,77.097c2.849,3.505,27.309,32.972,36.701,44.282 c1.758-0.549,3.63-0.847,5.569-0.847c10.274,0,18.616,8.334,18.616,18.616s-8.342,18.619-18.616,18.619 c-10.282,0-18.617-8.337-18.617-18.619c0-2.925,0.675-5.687,1.876-8.148c-20.727-24.082-107.41-124.756-110.789-128.137 c-15.64-17.294-37.484-23.072-58.918-16.267c-21.484,6.816-35.805,23.153-35.805,44.768c0,38.642,0,76.27,0,114.239 c0,28.371,25.532,48.332,53.118,48.115c27.688-0.213,47.427-20.842,52.036-48.934c2.471-15.081,0.124-37.928,0.124-37.928 l-32.407-38.838c-4.365-5.466-8.307-10.793-10.613-10.371c-2.523,0.461-3.258,3.709-3.258,7.704v7.228v49.199 c6,2.689,12.769,9.451,12.769,17.369c0,10.282-7.903,18.619-18.188,18.619c-10.275,0-20.34-8.337-20.34-18.619 c0-7.815,5.76-14.5,10.76-17.262v-49.307v-15.354c0-6.993,4.542-13.721,11.668-15.62c11.16-2.975,18.404,7.212,22.988,12.777 c22.154,26.894,83.767,101.644,103.385,121.262c24.949,24.95,59.779,23.974,81.9,0.693c22.705-23.884,15.668-66.072-8.419-89.714 C4201.243,1076.454,4184.41,1058.98,4176.084,1049.794z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 4169.253,
    cy: 1130.263,
    r: 9.307
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    cx: 4169.253,
    cy: 1032.475,
    r: 9.307
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_4",
    style: {
      display: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2310bb58a4c9041d3596e1fb9a4cba28.svg";
export { ForwardRef as ReactComponent };